import { useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const prevPathname = useRef(pathname);
  const prevPage = useRef(searchParams.get("page"));

  useEffect(() => {
    if (pathname !== prevPathname.current || searchParams.get("page") !== prevPage.current) {
      requestAnimationFrame(() => { window.scrollTo(0, 0);})
      prevPathname.current = pathname;
      prevPage.current = searchParams.get("page");
    }
  }, [pathname, searchParams]);

  return null;
}